/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { userAgent } from '../constants/common.constants';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  constructor() {
  }

  get isNativeApp() {
    return window.navigator.userAgent.toLowerCase().trim().includes(userAgent.toLowerCase());
  }

  getPascalCase(src: string) {
    return src?.replace(/(\w)(\w*)/g, (g0, g1, g2) => {
      return g1.toUpperCase() + g2.toLowerCase();
    });
  }

  log(message: string) {
    window['logWithTime'](message);
  }
  getFormattedPhoneNumber(phoneNumber: string): string {
    if(phoneNumber===null || phoneNumber === '' || phoneNumber === undefined)
      return '';

    // Remove the leading '+' and any non-digit characters
    const numericPart = phoneNumber.replace(/\D/g, '');

    // Use regular expression to format the last 10 digits
    const formattedNumber = numericPart.slice(-10).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

    return formattedNumber;
  }

  public getPhoneNumberInE164(phoneNumber: string): string {

    // Regular expression to check if the phone number is in E.164 format
    const e164Regex = /^\+[1-9]\d{1,14}$/;

    // Check if the phone number is already in E.164 format
    if (e164Regex.test(phoneNumber)) {
      return phoneNumber.slice(-10); //since Elita doesnt support more than 10 digits; remove country code
      return phoneNumber; // No need to convert, it's already in E.164 format
    }

    phoneNumber = phoneNumber.replace(/\D/g, '');

    // Only handling US phone format for now
    // Check if the phone number has only 10 digits (no country code), then add '+1'
    if (/^\d{10}$/.test(phoneNumber)) {
      return `${phoneNumber}`; //since Elita doesnt support more than 10 digits; remove country code
      return `+1${phoneNumber}`;
    }

    // Check if the phone number has only 11 digits (no country code), then add '+'
    if (/^\d{11}$/.test(phoneNumber)) {
      return phoneNumber.slice(-10); //since Elita doesnt support more than 10 digits; remove country code
      return `+${phoneNumber}`;
    }
  }

  public getPhoneNumberForTwilio(phoneNumber: string): string {

    // Regular expression to check if the phone number is in E.164 format
    const e164Regex = /^\+[1-9]\d{1,14}$/;

    // Check if the phone number is already in E.164 format
    if (e164Regex.test(phoneNumber)) {
      return phoneNumber; // No need to convert, it's already in E.164 format
    }

    phoneNumber = phoneNumber.replace(/\D/g, '');

    // Only handling US phone format for now
    // Check if the phone number has only 10 digits (no country code), then add '+1'
    if (/^\d{10}$/.test(phoneNumber)) {
      return `+1${phoneNumber}`;
    }

    // Check if the phone number has only 11 digits (no country code), then add '+'
    if (/^\d{11}$/.test(phoneNumber)) {
      return `+${phoneNumber}`;
    }
  }

  isValidPhoneFormat(phoneNumber) {
    var isphone = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g.test(phoneNumber);
    return isphone;
  }

  expandFAQ(input: string): string {
    const match = input.match(/^(.+?)\(([\d,]+)\)$/);
    if (!match) return '';
 
    const base = match[1]; // "FAQ_Addons_Home_Question"
    const numbers = match[2].split(','); // ["1", "2", "3", "4"]
 
    const result = numbers.flatMap(num => [
      `${base}_${num}`,
      `${base.replace('Question', 'Answer')}_${num}`
    ]);
 
    return result.join(';');
  }
 
  expandSetting(input: string): string {
    const match = input.match(/^(.+?)\(([\d,]+)\)$/);
    if (!match) return '';

    const base = match[1]; // "FAQ_Addons_Home_Question"
    const numbers = match[2].split(','); // ["1", "2", "3", "4"]

    const result = numbers.flatMap(num => [
      `${base}_${num}`
    ]);

    return result.join(';');
  }
}
